export const VOUCHER_TYPE_OPTIONS = [
  { value: 'INVOICE', label: '發票' },
  { value: 'RECEIPT', label: '收據' },
];

export const VOUCHER_STATUS_LABEL = {
  DRAFT: '草稿',
  ACTIVE: '有效',
  CANCELLED: '已作廢',
};

export const VOUCHER_STATUS_FILTER_OPTIONS = Object.entries(
  VOUCHER_STATUS_LABEL,
).map(([value, label]) => ({ value, label }));

export const VOUCHER_LIST_SORT_FIELD_LABELS = {
  voucherNo: '憑證號碼',
  voucherType: '類型',
  status: '狀態',
  totalAmount: '總額',
  voucherDate: '憑證日期',
  voucher_no: '憑證號碼',
  voucher_type: '類型',
  voucher_date: '憑證日期',
};

export function formatVoucherTypeLabel(type) {
  const matched = VOUCHER_TYPE_OPTIONS.find((option) => option.value === type);
  return matched?.label ?? type ?? '—';
}

export function formatVoucherStatusLabel(status) {
  return VOUCHER_STATUS_LABEL[status] ?? status ?? '—';
}

export function canEditVoucher(status) {
  return status === 'DRAFT' || !status;
}

export function canDeleteVoucher(status) {
  return status === 'DRAFT';
}

export function canSubmitVoucher(status) {
  return status === 'DRAFT';
}

/** 已被請款單引用時後端回 409 VOUCHER_IN_USE */
export function canCancelVoucher(status) {
  return status === 'ACTIVE';
}

export function canManageVoucherAttachments(status) {
  return status === 'DRAFT' || status === 'ACTIVE';
}
